export default __webpack_public_path__ + "static/p4-ee15fa6ecbc6ceb23d681ad1cfbc05ab.png";